import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { DEFAULT_BREAKPOINT, useBreakpointValue } from '@hub/design-system-base';
import { Box } from '@hub/box';
import { Frame } from '@hub/frame';
import { Image as ChakraImage } from '@chakra-ui/image';
import { Video } from '../video';
import makeImageUrl from './helpers/make-image-url';
import findBestImage from './helpers/find-best-image';
import { asArray } from './helpers/maybe-array'; // series of growing image widths to allow the browser to choose the best
// eslint-disable-next-line no-magic-numbers

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const availableSourceSizes = [100, 200, 300, 450, 600, 750, 900, 1072]; // eslint-disable-next-line no-magic-numbers

const availableDevicePixelRatios = [1, 2];
const availableSources = availableSourceSizes.flatMap(size => availableDevicePixelRatios.map(ratio => ({
  size,
  ratio
})));
export function CloudinaryImage({
  ratio,
  imageSetOrImage,
  preferredImageType,
  resizeMode,
  maxWidth,
  minWidth,
  sx,
  as,
  imageRef,
  sizes,
  className,
  loadingMode
}) {
  var _preferredImage$alt;

  const currentRatio = useBreakpointValue(asArray(ratio), DEFAULT_BREAKPOINT);
  const currentPrerredImageType = useBreakpointValue(asArray(preferredImageType), DEFAULT_BREAKPOINT);
  const currentResizeMode = useBreakpointValue(asArray(resizeMode), DEFAULT_BREAKPOINT);
  const preferredImage = findBestImage(imageSetOrImage, currentPrerredImageType);
  const srcset = availableSources.map(srcOption => {
    const src = makeImageUrl(preferredImage, currentRatio, currentResizeMode, srcOption.size, srcOption.ratio); // we can't specify both dpr and width in srcset so we just multiply size and ratio

    return "".concat(src, " ").concat(srcOption.size * srcOption.ratio, "w");
  }).join(', ');
  return /*#__PURE__*/_jsx(Frame, {
    ref: imageRef,
    as: as,
    ratio: ratio,
    minWidth: minWidth,
    maxWidth: maxWidth,
    sx: _objectSpread({
      position: 'relative',
      isolation: 'isolate'
    }, sx),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ChakraImage, {
        alt: (_preferredImage$alt = preferredImage.alt) !== null && _preferredImage$alt !== void 0 ? _preferredImage$alt : undefined,
        boxSize: "size-full",
        loading: loadingMode !== null && loadingMode !== void 0 ? loadingMode : 'lazy',
        srcSet: srcset,
        sizes: sizes === null || sizes === void 0 ? void 0 : sizes.join(', '),
        className: className
      }), preferredImage.cinemagraphUrl && /*#__PURE__*/_jsx(Box, {
        sx: {
          position: 'absolute',
          width: '100%',
          height: '100%'
        },
        className: className,
        children: /*#__PURE__*/_jsx(Video, {
          wide: ratio === '21/9',
          url: preferredImage.cinemagraphUrl
        })
      })]
    })
  });
}